import houseDescriptionChange from './actions/houseDescriptionChange';
import houseDescriptionCreate from './actions/houseDescriptionCreate';
import houseDescriptionDetail from './actions/houseDescriptionDetail';
import houseDescriptionList from './actions/houseDescriptionList';
import getHouseDescription from './getters/getHouseDescription';
import houseDescriptionUpload from './mutations/houseDescriptionUpload';

const actions = {
    houseDescriptionChange,
    houseDescriptionCreate,
    houseDescriptionDetail,
    houseDescriptionList
};

const mutations = {
    houseDescriptionUpload
};

const getters = {
    getHouseDescription
};

export default { actions, mutations, getters };
